import React, { useState } from 'react';
import {
  Mail, CheckCircle, Star, UserPlus, CreditCard, AlertTriangle,
  MessageSquare, RefreshCw, Bell, Search, Eye, X, Send,
  Globe, Lock, ShieldCheck, ChevronDown
} from 'lucide-react';

// ── E-posta kataloğu (tüm sistem e-postaları) ────────────────────────────────
const EMAIL_CATALOG = [
  {
    id: 'welcome',
    category: 'Hesap',
    trigger: 'Kayıt (Signup)',
    subject_en: 'Welcome to EXPO STAND!',
    subject_tr: 'EXPO STAND\'a Hoş Geldiniz!',
    recipient: 'Yeni kullanıcı',
    timing: 'Anlık',
    status: 'active',
    lang: 'both',
    icon: UserPlus,
    color: 'emerald',
    description_en: 'Sent immediately after account creation. Includes role information and dashboard link.',
    description_tr: 'Hesap oluşturulduktan hemen sonra gönderilir. Rol bilgisi ve dashboard linki içerir.',
    template_preview: `Hi [Name]! Your [Role] account is ready. You're now part of the world's leading exhibition management platform.`,
  },
  {
    id: 'password_reset',
    category: 'Hesap',
    trigger: 'Şifre Sıfırlama Talebi',
    subject_en: 'EXPO STAND — Password Reset Code',
    subject_tr: 'EXPO STAND — Şifre Sıfırlama Kodu',
    recipient: 'Şifresini unutan kullanıcı',
    timing: 'Anlık',
    status: 'active',
    lang: 'en',
    icon: Lock,
    color: 'blue',
    description_en: 'Sends a 6-digit reset code. Expires in 30 minutes.',
    description_tr: '6 haneli sıfırlama kodu gönderilir. 30 dakika geçerlidir.',
    template_preview: `Use the code below to reset your password. This code expires in 30 minutes. [CODE]`,
  },
  {
    id: 'team_invite',
    category: 'Ekip',
    trigger: 'Ekip Daveti Gönderildi',
    subject_en: 'You\'re invited to join [Org Name] on EXPO STAND',
    subject_tr: 'EXPO STAND\'da [Şirket Adı]\'na davet edildiniz',
    recipient: 'Davet edilen kişi',
    timing: 'Anlık',
    status: 'active',
    lang: 'en',
    icon: UserPlus,
    color: 'orange',
    description_en: 'Sent when an admin invites a new team member. Includes signup link and invite code. Expires in 7 days.',
    description_tr: 'Admin yeni ekip üyesi davet ettiğinde gönderilir. Kayıt linki ve davet kodu içerir. 7 gün geçerlidir.',
    template_preview: `You've been invited to join [Org Name] on EXPO STAND as a [Role]. [Accept Invitation Button]`,
  },
  {
    id: 'proposal_accepted',
    category: 'Teklif',
    trigger: 'Teklif Kabul Edildi',
    subject_en: 'Quote Accepted — [Brief Title]',
    subject_tr: 'Teklifiniz Kabul Edildi — [Brief Başlığı]',
    recipient: 'Contractor (teklif veren)',
    timing: 'Anlık',
    status: 'active',
    lang: 'en',
    icon: CheckCircle,
    color: 'emerald',
    description_en: 'Sent to contractor when exhibitor accepts their proposal. Includes project link.',
    description_tr: 'Exhibitor teklifini kabul ettiğinde contractor\'a gönderilir. Proje linki içerir.',
    template_preview: `Congratulations! Your proposal for [Brief Title] was accepted by [Exhibitor Name]. Log in to view the project details.`,
  },
  {
    id: 'proposal_declined',
    category: 'Teklif',
    trigger: 'Teklif Reddedildi',
    subject_en: 'Quote Update — [Brief Title]',
    subject_tr: 'Teklif Güncellemesi — [Brief Başlığı]',
    recipient: 'Contractor (teklif veren)',
    timing: 'Anlık',
    status: 'active',
    lang: 'en',
    icon: X,
    color: 'red',
    description_en: 'Sent to contractor when exhibitor declines their proposal.',
    description_tr: 'Exhibitor teklifi reddettiğinde contractor\'a gönderilir.',
    template_preview: `Hi [Contractor Name], unfortunately your proposal for [Brief Title] was not selected this time.`,
  },
  {
    id: 'invoice_new',
    category: 'Fatura',
    trigger: 'Yeni Fatura Gönderildi',
    subject_en: 'EXPO STAND — New Invoice [Number]',
    subject_tr: 'EXPO STAND — Yeni Fatura [Numara]',
    recipient: 'Exhibitor (fatura alan)',
    timing: 'Anlık',
    status: 'active',
    lang: 'en',
    icon: CreditCard,
    color: 'blue',
    description_en: 'Sent to exhibitor when contractor sends a new invoice. Includes amount and due date.',
    description_tr: 'Contractor yeni fatura gönderdiğinde exhibitor\'a gönderilir. Tutar ve vade tarihi içerir.',
    template_preview: `You have received a new invoice from [Contractor Name]. Invoice #[Number] — Amount: [Amount] — Due: [Date]`,
  },
  {
    id: 'invoice_paid',
    category: 'Fatura',
    trigger: 'Fatura Ödendi',
    subject_en: 'EXPO STAND — Invoice [Number] Paid',
    subject_tr: 'EXPO STAND — Fatura [Numara] Ödendi',
    recipient: 'Contractor (fatura gönderen)',
    timing: 'Anlık',
    status: 'active',
    lang: 'en',
    icon: CheckCircle,
    color: 'emerald',
    description_en: 'Sent to contractor when exhibitor marks invoice as paid.',
    description_tr: 'Exhibitor faturayı ödenmiş olarak işaretlediğinde contractor\'a gönderilir.',
    template_preview: `Payment Confirmed. Invoice [Number] for [Project Title] has been marked as paid by [Exhibitor Name].`,
  },
  {
    id: 'invoice_overdue',
    category: 'Fatura',
    trigger: 'Fatura Vadesi Geçti',
    subject_en: 'EXPO STAND — Payment Reminder: Invoice [Number] is Overdue',
    subject_tr: 'EXPO STAND — Ödeme Hatırlatması: Fatura [Numara] Vadesi Geçti',
    recipient: 'Exhibitor (borçlu)',
    timing: 'Günlük (02:00 UTC)',
    status: 'active',
    lang: 'en',
    icon: AlertTriangle,
    color: 'red',
    description_en: 'Automated daily check at 02:00 UTC. Sent to exhibitors with overdue invoices.',
    description_tr: 'Her gün 02:00 UTC\'de otomatik kontrol edilir. Vadesi geçmiş fatura olan exhibitor\'lara gönderilir.',
    template_preview: `Payment Reminder: Invoice [Number] from [Contractor] is overdue by [N] day(s). Amount Due: [Amount]`,
  },
  {
    id: 'testimonial_received',
    category: 'Yorum',
    trigger: 'Yorum Gönderildi',
    subject_en: 'Your Review Has Been Received — EXPO STAND',
    subject_tr: 'Yorumunuz Alındı — EXPO STAND',
    recipient: 'Yorum yapan kişi (üye veya misafir)',
    timing: 'Anlık',
    status: 'active',
    lang: 'both',
    icon: MessageSquare,
    color: 'orange',
    description_en: 'Thank-you email sent immediately after review submission. Language follows user preference (EN/TR).',
    description_tr: 'Yorum gönderildikten hemen sonra teşekkür e-postası atılır. Dil kullanıcı tercihine göre belirlenir (EN/TR).',
    template_preview: `Thank you for your review! We've received it and it's currently under evaluation. It will be published once approved.`,
  },
  {
    id: 'testimonial_approved',
    category: 'Yorum',
    trigger: 'Yorum Onaylandı',
    subject_en: 'Your Review Has Been Approved — EXPO STAND',
    subject_tr: 'Yorumunuz Onaylandı — EXPO STAND',
    recipient: 'Yorum yapan üye',
    timing: 'Admin onayı sonrası',
    status: 'active',
    lang: 'both',
    icon: CheckCircle,
    color: 'emerald',
    description_en: 'Sent when admin approves a pending testimonial. Language follows user preference.',
    description_tr: 'Admin bekleyen yorumu onayladığında gönderilir. Dil kullanıcı tercihine göre belirlenir.',
    template_preview: `Your review has been approved! It is now visible in the reviews section.`,
  },
  {
    id: 'testimonial_featured',
    category: 'Yorum',
    trigger: 'Yorum Öne Çıkarıldı',
    subject_en: 'Your Review is Featured on EXPO STAND!',
    subject_tr: 'Yorumunuz EXPO STAND Ana Sayfasında!',
    recipient: 'Yorum yapan üye',
    timing: 'Admin öne çıkarma sonrası',
    status: 'active',
    lang: 'both',
    icon: Star,
    color: 'amber',
    description_en: 'Sent when admin marks a testimonial as "featured" (appears on homepage). Language follows user preference.',
    description_tr: 'Admin yorumu "öne çıkan" olarak işaretlediğinde gönderilir (ana sayfada gösterilir). Dil kullanıcı tercihine göre belirlenir.',
    template_preview: `Congratulations! Your review has been featured on the EXPO STAND homepage.`,
  },
  {
    id: 'reengagement_contractor',
    category: 'Yeniden Katılım',
    trigger: 'Contractor 7+ gün login yapmadı',
    subject_en: 'You have [N] new briefs waiting — EXPO STAND',
    subject_tr: '[N] yeni brief sizi bekliyor — EXPO STAND',
    recipient: 'Pasif Contractor',
    timing: 'Haftalık (Scheduler)',
    status: 'active',
    lang: 'en',
    icon: RefreshCw,
    color: 'green',
    description_en: 'Re-engagement email for contractors who have not logged in for 7+ days. Shows count of new briefs.',
    description_tr: '7+ gün giriş yapmayan contractor\'lara yeniden katılım e-postası. Yeni brief sayısını gösterir.',
    template_preview: `Hey [Name], don't miss out! [N] new stand briefs were published while you were away.`,
  },
  {
    id: 'reengagement_exhibitor',
    category: 'Yeniden Katılım',
    trigger: 'Exhibitor bekleyen teklif var + 7+ gün login yapmadı',
    subject_en: '[N] contractor proposals awaiting your review — EXPO STAND',
    subject_tr: '[N] yüklenici teklifini incelemeniz gerekiyor — EXPO STAND',
    recipient: 'Pasif Exhibitor',
    timing: 'Haftalık (Scheduler)',
    status: 'active',
    lang: 'en',
    icon: Bell,
    color: 'orange',
    description_en: 'Re-engagement email for exhibitors who have pending proposals and haven\'t logged in for 7+ days.',
    description_tr: 'Bekleyen teklifi olan ve 7+ gün giriş yapmayan exhibitor\'lara gönderilir.',
    template_preview: `[Name], you have proposals to review! [N] contractors have submitted quotes for your stand brief.`,
  },
  {
    id: 'subscription_expiry',
    category: 'Abonelik',
    trigger: 'Abonelik sona ermeden 7 / 3 gün önce',
    subject_en: 'Action Required: Your EXPO STAND subscription expires in [N] day(s)',
    subject_tr: 'İşlem Gerekiyor: Aboneliğiniz [N] gün sonra sona eriyor',
    recipient: 'Abonesi sona erecek üye',
    timing: 'Günlük Kontrol (Scheduler)',
    status: 'active',
    lang: 'en',
    icon: CreditCard,
    color: 'amber',
    description_en: 'Automated expiry warning at 7 days and 3 days before expiry. Red highlight for 3-day warning.',
    description_tr: 'Sona ermeden 7 ve 3 gün önce otomatik uyarı. 3 gün kaldığında kırmızı vurgu.',
    template_preview: `Your [Plan Name] subscription expires in [N] days. Renew now to avoid interruption to your service.`,
  },
];

// ── Renk yardımcıları ──────────────────────────────────────────────────────
const COLOR_MAP = {
  emerald: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', dot: 'bg-emerald-500', icon: 'text-emerald-600' },
  blue:    { bg: 'bg-blue-50',    text: 'text-blue-700',    border: 'border-blue-200',    dot: 'bg-blue-500',    icon: 'text-blue-600'    },
  orange:  { bg: 'bg-orange-50',  text: 'text-orange-700',  border: 'border-orange-200',  dot: 'bg-orange-500',  icon: 'text-orange-600'  },
  red:     { bg: 'bg-red-50',     text: 'text-red-700',     border: 'border-red-200',     dot: 'bg-red-500',     icon: 'text-red-600'     },
  amber:   { bg: 'bg-amber-50',   text: 'text-amber-700',   border: 'border-amber-200',   dot: 'bg-amber-500',   icon: 'text-amber-600'   },
  green:   { bg: 'bg-green-50',   text: 'text-green-700',   border: 'border-green-200',   dot: 'bg-green-500',   icon: 'text-green-600'   },
};

const CATEGORIES = ['Tümü', 'Hesap', 'Ekip', 'Teklif', 'Fatura', 'Yorum', 'Yeniden Katılım', 'Abonelik'];

const LANG_LABELS = {
  en:   { label: 'Sadece EN', bg: 'bg-blue-100 text-blue-700' },
  tr:   { label: 'Sadece TR', bg: 'bg-red-100 text-red-700' },
  both: { label: 'EN + TR',   bg: 'bg-purple-100 text-purple-700' },
};

export default function UltraEmailManagement() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [selectedEmail, setSelectedEmail] = useState(null);

  const filtered = EMAIL_CATALOG.filter(e => {
    const matchCat = activeCategory === 'Tümü' || e.category === activeCategory;
    const q = search.toLowerCase();
    const matchSearch = !q || e.trigger.toLowerCase().includes(q) ||
      e.subject_en.toLowerCase().includes(q) || e.recipient.toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  // KPI counts
  const totalActive = EMAIL_CATALOG.filter(e => e.status === 'active').length;
  const byCategory = CATEGORIES.slice(1).map(c => ({
    name: c,
    count: EMAIL_CATALOG.filter(e => e.category === c).length
  }));

  return (
    <div className="space-y-6" data-testid="email-management-page">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">E-posta Yönetimi</h1>
          <p className="text-sm text-gray-500 mt-1">
            Sistemdeki tüm otomatik e-postaların kataloğu ve tetikleyici bilgileri
          </p>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 text-emerald-700 text-xs font-semibold rounded-full border border-emerald-200">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            {totalActive} Aktif E-posta
          </span>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {[
          { label: 'Toplam E-posta', value: EMAIL_CATALOG.length, icon: Mail, color: 'blue' },
          { label: 'Dil Destekli (EN+TR)', value: EMAIL_CATALOG.filter(e => e.lang === 'both').length, icon: Globe, color: 'purple' },
          { label: 'Anlık Tetiklenen', value: EMAIL_CATALOG.filter(e => e.timing === 'Anlık').length, icon: Send, color: 'orange' },
          { label: 'Otomatik (Scheduler)', value: EMAIL_CATALOG.filter(e => e.timing.includes('Scheduler') || e.timing.includes('UTC')).length, icon: RefreshCw, color: 'emerald' },
        ].map(({ label, value, icon: Icon, color }) => (
          <div key={label} className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3 shadow-sm">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
              color === 'blue' ? 'bg-blue-50' : color === 'purple' ? 'bg-purple-50' :
              color === 'orange' ? 'bg-orange-50' : 'bg-emerald-50'
            }`}>
              <Icon className={`w-5 h-5 ${
                color === 'blue' ? 'text-blue-600' : color === 'purple' ? 'text-purple-600' :
                color === 'orange' ? 'text-orange-600' : 'text-emerald-600'
              }`} />
            </div>
            <div>
              <p className="text-xl font-bold text-gray-900">{value}</p>
              <p className="text-xs text-gray-500">{label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
        <div className="flex flex-wrap items-center gap-3">
          {/* Search */}
          <div className="relative flex-1 min-w-[200px]">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Tetikleyici, konu veya alıcı ara..."
              className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              data-testid="email-search-input"
            />
          </div>
          {/* Category chips */}
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-3 py-1.5 text-xs font-semibold rounded-full border transition-colors ${
                  activeCategory === cat
                    ? 'bg-gray-900 text-white border-gray-900'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400'
                }`}
              >
                {cat}
                {cat !== 'Tümü' && (
                  <span className="ml-1.5 opacity-70">
                    ({byCategory.find(b => b.name === cat)?.count || 0})
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Email Table */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full" data-testid="email-catalog-table">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase">E-posta</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Tetikleyici</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase hidden md:table-cell">Alıcı</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase hidden lg:table-cell">Zamanlama</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Dil</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Durum</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filtered.map(email => {
                const c = COLOR_MAP[email.color] || COLOR_MAP.blue;
                const Icon = email.icon;
                const langMeta = LANG_LABELS[email.lang];
                return (
                  <tr key={email.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className={`w-9 h-9 rounded-lg ${c.bg} flex items-center justify-center flex-shrink-0`}>
                          <Icon className={`w-4 h-4 ${c.icon}`} />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-900 leading-tight">{email.subject_en}</p>
                          {email.subject_tr !== email.subject_en && (
                            <p className="text-xs text-gray-400 mt-0.5 truncate max-w-[240px]">{email.subject_tr}</p>
                          )}
                          <span className="mt-0.5 inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded bg-gray-100 text-gray-500">
                            {email.category}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <p className="text-sm text-gray-700">{email.trigger}</p>
                    </td>
                    <td className="px-4 py-3 hidden md:table-cell">
                      <p className="text-sm text-gray-600">{email.recipient}</p>
                    </td>
                    <td className="px-4 py-3 hidden lg:table-cell">
                      <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full ${
                        email.timing === 'Anlık' ? 'bg-blue-50 text-blue-700' :
                        email.timing.includes('Scheduler') || email.timing.includes('UTC') ? 'bg-amber-50 text-amber-700' :
                        'bg-gray-100 text-gray-600'
                      }`}>
                        {email.timing}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`inline-block text-[10px] font-semibold px-2 py-1 rounded-full ${langMeta.bg}`}>
                        {langMeta.label}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 px-2 py-1 rounded-full">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                        Aktif
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <button
                        onClick={() => setSelectedEmail(email)}
                        className="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                        data-testid={`email-view-${email.id}`}
                        title="Detayları gör"
                      >
                        <Eye className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                );
              })}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={7} className="px-4 py-12 text-center text-sm text-gray-400">
                    <Mail className="w-8 h-8 mx-auto mb-2 opacity-30" />
                    Arama kriteriyle eşleşen e-posta bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Detail Modal */}
      {selectedEmail && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={e => e.target === e.currentTarget && setSelectedEmail(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
            <div className={`px-6 py-4 border-b flex items-start justify-between ${COLOR_MAP[selectedEmail.color]?.bg || 'bg-gray-50'}`}>
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-xl ${COLOR_MAP[selectedEmail.color]?.bg || 'bg-gray-100'} flex items-center justify-center`}>
                  {React.createElement(selectedEmail.icon, { className: `w-5 h-5 ${COLOR_MAP[selectedEmail.color]?.icon || 'text-gray-600'}` })}
                </div>
                <div>
                  <h2 className="text-base font-bold text-gray-900">{selectedEmail.trigger}</h2>
                  <span className="text-xs text-gray-500">{selectedEmail.category}</span>
                </div>
              </div>
              <button onClick={() => setSelectedEmail(null)} className="p-1.5 hover:bg-black/10 rounded-lg transition-colors">
                <X className="w-5 h-5 text-gray-600" />
              </button>
            </div>

            <div className="p-6 space-y-5">
              {/* Konu */}
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase mb-2">E-posta Konusu</p>
                <div className="space-y-2">
                  <div className="flex items-start gap-2">
                    <span className="text-[10px] font-bold px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded mt-0.5">EN</span>
                    <p className="text-sm text-gray-800">{selectedEmail.subject_en}</p>
                  </div>
                  {selectedEmail.subject_tr !== selectedEmail.subject_en && (
                    <div className="flex items-start gap-2">
                      <span className="text-[10px] font-bold px-1.5 py-0.5 bg-red-100 text-red-700 rounded mt-0.5">TR</span>
                      <p className="text-sm text-gray-800">{selectedEmail.subject_tr}</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Detaylar */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Alıcı</p>
                  <p className="text-sm text-gray-800">{selectedEmail.recipient}</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Zamanlama</p>
                  <p className="text-sm text-gray-800">{selectedEmail.timing}</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Dil Desteği</p>
                  <span className={`inline-block text-xs font-semibold px-2 py-1 rounded-full ${LANG_LABELS[selectedEmail.lang].bg}`}>
                    {LANG_LABELS[selectedEmail.lang].label}
                  </span>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Durum</p>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 px-2 py-1 rounded-full">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                    Aktif
                  </span>
                </div>
              </div>

              {/* Açıklama */}
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Açıklama</p>
                <div className="flex items-start gap-2 mb-1">
                  <span className="text-[10px] font-bold px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded mt-0.5">EN</span>
                  <p className="text-sm text-gray-600">{selectedEmail.description_en}</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-[10px] font-bold px-1.5 py-0.5 bg-red-100 text-red-700 rounded mt-0.5">TR</span>
                  <p className="text-sm text-gray-600">{selectedEmail.description_tr}</p>
                </div>
              </div>

              {/* Şablon önizleme */}
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Şablon Önizleme</p>
                <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-200">
                    <div className="w-6 h-6 bg-gray-900 rounded flex items-center justify-center">
                      <span className="text-orange-400 font-black text-[9px]">E</span>
                    </div>
                    <span className="text-xs font-bold text-gray-800">EXPO STAND</span>
                    <span className="ml-auto text-xs text-gray-400">no-reply@expostand.com</span>
                  </div>
                  <p className="text-xs text-gray-700 leading-relaxed">{selectedEmail.template_preview}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
